export default __webpack_public_path__ + "static/media/destination2.7d0d91eb.jpg";